import { TrackingSettings } from '../../configs/tracking-settings';
import { TrackingState } from './tracking-state';

const PAGE_LINK_DATA = {
    trackingCode: '',
    asset: null,
    obj: {}
}

export class TrackingProxy {
    constructor(settings = {}, amp) {
        let defaultSettings = new TrackingSettings();
        this._amp = amp;
        this._settings = Object.assign(defaultSettings, settings);
        this._state = null;
        this._subscriptions = [];
    }
    get amp() {
        return this._amp;
    }
    get allowEvents(){
        if(this._allowEvents == null){
            this._allowEvents = {};
            this.trackingEvents.forEach( eventName => {
                this._allowEvents[eventName] = {
                    disable: false,
                    disableOnce: true
                }
            })
        }
        return this._allowEvents;
    }
    get milestones() {
        return this.state.milestones;
    }
    get playerName() {
        return this.settings.playerName;
    }
    get moduleName() {
        return this.settings.moduleName;
    }
    get settings() {
        return this._settings;
    }
    get state() {
        if (this._state == null) {
            this._state = new TrackingState();
        }
        return this._state;
    }
    set state(state = null) {
        this._state = state;
    }
    get subscriptions() {
        return this._subscriptions;
    }
    get trackingEvents() {
        let trackingEvents = ["autoplayblocked", "cc_visibilitychange","loadeddata", "bufferingchange", "fullscreenchange", "started", "play", "playing", "pause", "ended", "timeupdate", "volumechange", "mutechange", "seeking", "seeked"]
    
        return trackingEvents;
    }

    get PAGE_LINK_DATA() {
        return Object.assign({}, PAGE_LINK_DATA);
    }

    get NEW_CONTEXT_VARS() {
        return [
            'wb.vdname',
            'wb.vdnameid',
            'wb.toolin',
            'wb.sptr',
            'wb.sact',
            'wb.sactid',
            'wb.sprod',
            'wb.sprodid',
            'wb.spcrtid',
            'wb.actid'
        ];
    }
}